import React, { createContext, useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { SnackbarProvider } from "notistack";
import { AuthProvider } from "./utils/useAuth/useAuth";
import RoutesConfig from "./routes/RouterConfig";
import { ThemeProvider } from "@emotion/react";
import { theme } from "theme/theme";
import { StyledSnackbar } from "theme/notistackTheme";

export const PortalContext = createContext();

const App = () => {
  const [currentPath, setCurrentPath] = useState("");
  const [detailPageState, setDetailPageState] = useState({});

  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <PortalContext.Provider
          value={{
            currentPath,
            setCurrentPath,
            detailPageState,
            setDetailPageState,
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <SnackbarProvider
              disableWindowBlurListener={true}
              maxSnack={3}
              Components={{
                info: StyledSnackbar,
                success: StyledSnackbar,
                warning: StyledSnackbar,
                error: StyledSnackbar,
              }}
              style={{
                fontFamily: "sans-serif",
                fontSize: "16px",
                fontWeight: 500,
                lineHeight: "165%",
              }}
            >
              <RoutesConfig />
            </SnackbarProvider>
          </LocalizationProvider>
        </PortalContext.Provider>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
